module.exports = __webpack_public_path__ + "img/travel_step2.8493fe3e.svg";